import { IDopplerRequest } from '@models/doppler-request.model';
import { IClient } from '@models/client.model';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppStateUser } from 'src/app/state/user/user.reducer';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { EMAIL_REGEX } from '@shared/utils';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { MatFormFieldModule } from '@angular/material/form-field';


@Component({
    selector: 'app-newsletter',
    templateUrl: './newsletter.component.html',
    styleUrls: ['./newsletter.component.scss'],
    standalone: true,
    imports: [LottieComponent, MatFormFieldModule, LazyLoadImageModule, MatIconModule, FormsModule, ReactiveFormsModule, MatInputModule, MatButtonModule, TranslateModule]
})
export class NewsletterComponent implements OnInit, OnDestroy {

  public requestDoppler: IDopplerRequest;
  public fieldsDoppler: any[] = [];
  public client: IClient;
  public newsLetterForm: UntypedFormGroup;
  public loading = false;
  public options: AnimationOptions = {
    path: '/assets/animations/loader.json',
  };

  private subs = new Subject<void>();

  public image = '/../../assets/images/newsletter-background.webp';

  constructor(
    private fb: UntypedFormBuilder,
    private authService: AuthService,
    private snackbarService: SnackbarService,
    private store: Store<AppStateUser>
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.store.select('user').pipe(takeUntil(this.subs)).subscribe(({ data }) => {
      this.client = data;
    });
  }

  ngOnDestroy(): void {
    this.subs.next();
    this.subs.complete();
  }

  public createForm(): void {
    this.newsLetterForm = this.fb.group({
      email: ['', [Validators.required, Validators.email, Validators.pattern(EMAIL_REGEX)
      ]]
    });
  }

  public async subscribeNewsLetter(): Promise<void> {
    this.loading = true;
    this.fieldsDoppler = [];
    const { email } = this.newsLetterForm.value;
    if (this.client?.name) {
      this.fieldsDoppler.push({
        name: 'FIRSTNAME',
        value: this.client?.name,
        predefined: true,
        private: true,
        readonly: true
      });
    }
    if (this.client?.lastname) {
      this.fieldsDoppler.push({
        name: 'LASTNAME',
        value: this.client?.lastname,
        predefined: true,
        private: true,
        readonly: true
      });
    }
    if (this.client?.date_birth) {
      this.fieldsDoppler.push({
        name: 'BIRTHDAY',
        value: this.client?.date_birth,
        predefined: true,
        private: true,
        readonly: true
      });
    }
    this.requestDoppler = {
      email,
      fields: this.fieldsDoppler
    };
    try {
      await this.authService.subscribeNewsLetter(this.requestDoppler);
      this.snackbarService.openSnackbar('GENERAL.newsLetter', 'success');
      this.newsLetterForm.reset();
      this.loading = false;
    } catch (error) {
      this.loading = false;
      this.newsLetterForm.reset();
      this.snackbarService.openSnackbar('AUTH.ERROR.newsLetter', 'warn');
    }
  }

}
